
import ResponsiveDialog from "../dialogs/responsive-dialog.vue";
import MenuUploadAddonsEmpty from "../menu/menu-upload-addons-empty.vue";

export default {
  components: {
    ResponsiveDialog,
    MenuUploadAddonsEmpty
  },
  props: {
    dialog: Boolean
  }
};
